import React from 'react';
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  ButtonGroup
} from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import '../assets/styles/contacts.css';

function ContactTable({ searchTerm, contacts, removeContact, onEditContact }) {
  const history = useHistory();

  const filteredContacts = contacts.filter(
    (contact) =>
      contact.firstName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      contact.lastName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const goToContactPage = (contact) => {
    const slug = `${contact.id}`;
    history.push(`/contacts/${slug}`);
  };

  return (
    <Table className="contacts-table">
      <TableHead>
        <TableRow>
          <TableCell>First Name</TableCell>
          <TableCell>Last Name</TableCell>
          <TableCell>Phone Number</TableCell>
          <TableCell>E-mail</TableCell>
          <TableCell>Actions</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {filteredContacts.map((contact, index) => (
          <TableRow key={index}>
            <TableCell>{contact.firstName}</TableCell>
            <TableCell>{contact.lastName}</TableCell>
            <TableCell>{contact.phoneNumber}</TableCell>
            <TableCell>{contact.email}</TableCell>
            {/*
              Prevent wrapping by either:
              1) Using inline style: style={{ whiteSpace: 'nowrap' }}
              2) Or a custom CSS class with .no-wrap { white-space: nowrap; }
            */}
            <TableCell style={{ whiteSpace: 'nowrap' }}>
              <ButtonGroup variant="contained" size="small" aria-label="actions">
                <Button
                  color="primary"
                  onClick={() => goToContactPage(contact)}
                >
                  DETAILS
                </Button>
                <Button onClick={() => onEditContact(contact)}>EDIT</Button>
                <Button
                  // color="secondary"
                  onClick={() => removeContact(index)}
                >
                  REMOVE
                </Button>
              </ButtonGroup>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}

export default ContactTable;
